import cn from 'classnames';
import styles from './ReviewItem.module.scss';
import { FETCH_METHODS, ReviewType } from '@/types';
import { Rating } from '@/atoms/Rating';
import { getBackendImage } from '@/utils/getBackendImage';
import { ThumbLikeButton } from '@/atoms/ThumbLikeButton';
import { ThumbDislikeButton } from '@/atoms/ThumbDislikeButton';
import { UserComment } from '@/atoms/UserComment';
import { useState } from 'react';
import { ModalGallery } from '@/atoms/ModalGallery';
import { useBodyScrollLock } from '@/hooks/useBodyScrollLock';
import { fetchData, getTokens } from '@/services';
import { useDispatch } from 'react-redux';
import { setShowAuthModal } from '@/store';

type ReviewItemProps = {
  className?: string;
  review: ReviewType;
  onReact: () => void;
};

export function ReviewItem({ className, review, onReact }: ReviewItemProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const [showModalGallery, setShowModalGallery] = useState(false);
  useBodyScrollLock(showModalGallery);
  const { accessToken } = getTokens();
  const dispatch = useDispatch();

  const handleLike = async () => {
    if (!accessToken) {
      dispatch(setShowAuthModal(true));
      return;
    }

    const response = await fetchData({
      url: `/form/review/${review.id}/like`,
      method: FETCH_METHODS.POST,
    });

    if (response.success) {
      onReact();
      return;
    }
  };

  const handleDislike = async () => {
    if (!accessToken) {
      dispatch(setShowAuthModal(true));
      return;
    }

    const response = await fetchData({
      url: `/form/review/${review.id}/dislike`,
      method: FETCH_METHODS.POST,
    });

    if (response.success) {
      onReact();
      return;
    }
  };

  return (
    <div className={wrapperClassName}>
      <div className={styles.header}>
        <Rating rating={review.rating} isBig isWithText={false} />
        <span className={styles.date}>{review.date}</span>
      </div>
      <UserComment isAnonymous={review.isAnonymous} user={review.user} />
      <div className={styles.points}>
        <div className={styles.row}>
          <span className={styles.pointTitle}>Достоинства: </span>
          <span className={styles.pointText}>{review.advantages}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.pointTitle}>Недостатки: </span>
          <span className={styles.pointText}>{review.flaws}</span>
        </div>
        <div className={styles.description}>
          <span className={styles.text}>{review.description}</span>
        </div>
      </div>
      <div className={styles.images}>
        {review.photo.map((image) => (
          <img
            src={getBackendImage(image)}
            alt="review"
            className={styles.image}
            key={image}
            onClick={() => setShowModalGallery(true)}
          />
        ))}
      </div>
      <div className={styles.feedback}>
        <span className={styles.feedbackTitle}>Вам полезен этот отзыв?</span>
        <div className={styles.feedbackButtons}>
          <ThumbLikeButton
            count={review.countLike}
            onClick={handleLike}
            isFilled={review.userHaveLike}
          />
          <ThumbDislikeButton
            count={review.countDislike}
            onClick={handleDislike}
            isFilled={review.userHaveDislike}
          />
        </div>
      </div>
      <ModalGallery
        active={showModalGallery}
        onClose={() => setShowModalGallery(false)}
        items={review.photo}
      />
    </div>
  );
}
